import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Draggable from 'gsap/Draggable.js'
gsap.registerPlugin(Draggable)

import { MotionPathPlugin } from 'gsap/MotionPathPlugin.js'
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin.js'
gsap.registerPlugin(MotionPathPlugin, DrawSVGPlugin);
import { SplitText } from 'gsap/SplitText.js'
import { log } from 'handlebars';
gsap.registerPlugin(SplitText);


class Events extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.i = 0


    this.ref = {
      title: [],
      card: [],
      cardbottom: [],
      words: [],
      tech: [],
      letter: []
    }

  }

  mount() {

  
   
    this.ref.title.forEach((item, i) => {

        const title = new SplitText(item, {
            type: "words",
            wordsClass: 'word'
        })

        title.words.forEach((item, i) => {
            item.style = `--word-index: ${i}`
        })

        ScrollTrigger.create({
          trigger: item,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            item.classList.add("visible")
          },
          once: true
        });


    })

    

    this.ref.words.forEach((item, i) => {

      const title = new SplitText(item, {
        type: "words",
        wordsClass: 'word'
      })

      title.words.forEach((item, i) => {
        item.style = `--word-index: ${i}`
      })

    })

    this.ref.tech.forEach((item, i) => {

      const title = new SplitText(item, {
        type: "words",
        wordsClass: 'word'
      })

      title.words.forEach((item, i) => {
        item.classList.add (`word--${i}`)
      })

    })

    this.ref.letter.forEach((item, i) => {

      const title = new SplitText(item, {
        type: "chars",
        charsClass: "char"
      })

      title.chars.forEach((item, i) => {
        item.style = `--char-index: ${i}`
      })
      title.words.forEach((item, i) => {
        item.style = `--word-index: ${i}`
      })


     


    })

    


    this.ref.card.forEach((item, i) => {

      ScrollTrigger.create({
          trigger: item,
          start: "top bottom",
          onEnter: ({progress, direction, isActive}) => {
            item.classList.add("inview")
          },
          once: true
        });
    });

    this.ref.cardbottom.forEach((item, i) => {

      ScrollTrigger.create({
        trigger: item,
        start: "bottom bottom",
        onEnter: ({
          progress,
          direction,
          isActive
        }) => {
          item.classList.add("inview")
        },
        once: true
      });
    });




   
}


updateText(){
  var theLetters = "abcdefghijklmnopqrstuvwxyz#%&^+=-"; //You can customize what letters it will cycle through
  var ctnt = this.errortext; // Your text goes here
  var speed = 30; // ms per frame
  var increment = 3; // frames per step. Must be >2


  var clen = ctnt.length;
  var si = 0;
  var stri = 0;
  var block = "";
  var fixed = "";
  
  (function rustle(i) {
    setTimeout( ()=>{
      if (--i) {
        rustle(i);
      }
      nextFrame(i);
      si = si + 1;
    }, speed);
  })(clen * increment + 1);

   const nextFrame = (pos) => {
    for (var i = 0; i < clen - stri; i++) {
      //Random number
      var num = Math.floor(theLetters.length * Math.random());
      //Get random letter
      var letter = theLetters.charAt(num);
      block = block + letter;
    }
    if (si == (increment - 1)) {
      stri++;
    }
    if (si == increment) {
      // Add a letter; 
      // every speed*10 ms
      fixed = fixed + ctnt.charAt(stri - 1);
      si = 0;
    }
    $(this.ref.rand).html(fixed + block);
    block = "";
  }
}

      update() {
        const R = (x) => {
          const X = this.d1[x] < 10 ? '00' : this.d1[x] < 100 ? '0' : '';
          return X + this.d1[x]
        };

        this.ref.counter.innerHTML = R(0) + "%";
      };

      updateB() {
        const R = (x) => {
          const X = this.b1[x] < 10 ? '00' : this.b1[x] < 100 ? '0' : '';
          return X + this.b1[x]
        };

        this.ref.counter.innerHTML = R(0) + "%";
      };

  unmount() {




  }


}

module.exports = Events
 